import { Section, SectionHeading } from "@/components/common/Section";
import { useReveal } from "@/hooks/useReveal";
import { services } from "@/data/content";

function ServiceCard({ icon: Icon, title, desc, index }) {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${(index % 4) * 70}ms` }}
      data-testid={`service-card-${title.replace(/\s+/g, "-").toLowerCase()}`}
      className="reveal group relative bg-white border border-black/5 p-7 transition-all duration-300 hover:border-gold/60 hover:shadow-[0_20px_40px_rgba(10,31,68,0.08)] hover:-translate-y-1"
    >
      <span className="flex h-12 w-12 items-center justify-center bg-navy text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-navy">
        <Icon className="h-6 w-6" />
      </span>
      <h3 className="mt-5 font-heading text-lg md:text-xl text-navy">{title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-charcoal/70">{desc}</p>
    </div>
  );
}

export function Services() {
  return (
    <Section id="services" bg="mist">
      <SectionHeading
        eyebrow="What We Do"
        title="Comprehensive branding & signage services"
        subtitle="A complete suite of office branding, signage and printing services — engineered for premium finish and built to last."
        align="center"
      />
      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {services.map((s, i) => (
          <ServiceCard key={s.title} {...s} index={i} />
        ))}
      </div>
    </Section>
  );
}
